<template>
    <div>
        <!-- Card stats -->
        <transition name="alert-fade" mode="out-in">
            <b-alert :variant="variant" :show="dismissCountDown" dismissible @dismiss-count-down="countDownChanged" data-test="save-alert">
                {{ message }}
            </b-alert>
        </transition>
        
        <b-row>
            <!-- Inputs -->
            <b-col xl="5">
                <b-card>
                    <ToolInputs :fields="getScenarioByName(scenarioName).fields" :scenarioName="scenarioName"/>
                    <!-- A checkbox that model's the value of the scenario's beta mode setting -->
                    <b-col v-if="userIsInBetaGroup(scenarioName)" class="mt-3 mb--2">
                        <center>
                            <span class="label mr-5">Run Beta Rules:</span>
                            <b-form-checkbox v-model="getScenarioByName(scenarioName).runBetaRules" name="check-button" class="ml--2 mr-7 pt-2" inline switch></b-form-checkbox>
                        </center>
                    </b-col>

                    <!-- Run scenario button -->
                    <b-col>
                            <b-button 
                                class="my-3 run-button" 
                                variant="info" 
                                @click="runScenario($event);"
                            >Run Scenario</b-button>
                        
                    </b-col>
                </b-card>
            </b-col>
            <!-- End Inputs -->

            <!--Tables-->
            <b-col xl="7" class="mb-5 mb-xl-0">
                <rules-table :compare="false" :scenarioName="scenarioName"></rules-table>
            </b-col>
            <!--End tables-->
        </b-row>

        <!-- Overlay -->
        <v-overlay z-index="2000" :value="loading">
            <v-progress-circular indeterminate size="72" width="6" color="#40C4FF"></v-progress-circular>
        </v-overlay>
        <!-- End Overlay -->
    </div>
</template>
<script>
// Tables
import RulesTable from "../components/Results/RulesTable";
import ToolInputs from "../components/Inputs/ToolInputs/ToolInputs";
import useVuelidate from "@vuelidate/core";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ruleDialog, alertMixins, dialogMixins } from "@/mixins/dialog.js";

export default {
    components: {
        RulesTable,
        ToolInputs,
    },
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            loading: false,
            // show: false,
            scenarioName: "toolScenario",
        };
    },
    methods: {
        ...mapMutations([
            "setSelectedLoanId",
            "setInvalidSections",
            "removeRuleOverrides",
            "setUsers"
        ]),
        ...mapActions([
            "fetchScenario", 
            "fetchScenarioTimes", 
            "storeRunScenario", 
            "storeSaveScenario", 
            "checkChangeInExceptions",
            "fetchNewEncompassValues"
        ]),

        async runScenario(ev) {
            // runs scenario
            this.v$.$touch();
            this.alertOnInvalidFields(this.v$, ev, false);
            if (!this.v$.$invalid) {
                this.loading = true;
                let message = "";
                //calls the action that runs the scenario and gets any error messages that were thrown
                // TODO: add scenario name to call
                message = await this.storeRunScenario({scenarioName: this.scenarioName});
                this.countDownChanged(0);
                if (message !== "No Error") {
                    // if errors were thrown display an error alert
                    this.showAlert("danger", "There was an error when running this scenario." + message);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                } 
            }
            this.loading = false;
        },
    },
    computed: {
        ...mapGetters([
            "getHasRun",
            "getSaved",
            "getScenario",
            "getScenarioByName", 
            "getCompareOptions", 
            "getDisplayValueChangeMessage", 
            "getDisplayCompFactorMessage", 
            "getRulesToCrse", 
            "getIsLegacyLoan", 
            "getPassingCompFactorLength",
            "userIsInBetaGroup"
        ]),
    },
    watch: {
        v$: {
            handler(validation) {
                this.setInvalidSections({ scenario: this.scenarioName });
                this.setInvalidSections({ scenario: this.scenarioName, errors: validation.$errors });
            },
        },
    },
    mounted() {
        if (this.getScenario.id === null) {
            this.setSelectedLoanId(this.$route.params.id);
            this.fetchScenario({ scenario: "haloScenario" });
        } else {
            this.v$.$touch();
        }
        this.fetchScenario({ scenario: this.scenarioName });

        this.fetchScenarioTimes();
        // listener for updating encompass values
        document.addEventListener('updateEncompassValues', function() {
            this.fetchNewEncompassValues();
            }.bind(this));

        // listener for setting list of users
        document.addEventListener('grantedByUsers', function(e) {
            this.setUsers(e.detail)
            }.bind(this));
    },

    mixins: [ruleDialog, alertMixins, dialogMixins],
};
</script>
<style>
.alert-fade-enter-active {
    transition: all 1s ease;
    opacity: 0;
    transform: translateY(50px);
}

.alert-fade-enter-to {
    transition: all 1s ease;
    opacity: 1;
    transform: translateY(0);
}

.alert-fade-leave-to {
    transition: all 1s ease;
    opacity: 0;
}

.alert-fade-leave-active {
    transition: all 1s ease;
    transform: translateY(50px);
}
</style>

<style scoped>
.alert {
    width: 100%;
    margin-bottom: 1rem;
}
.ui-state-disabled:hover {
    cursor: default !important;
}

.run-button {
    background-color: #00afef;
    border-color: #00afef;
    margin-left: 31%;
    overflow: hidden;
}
</style>
